<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder='Pesquisável pelo campo "searchable"'
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Account</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label for="consult-status">Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>

        <div class="col-md-3">
          <label>Stage Name</label>
          <Select2 :options="filterStageName" v-model="query.stageName"/>
        </div>

        <div class="col-md-3">
          <label>Scraping Service</label>
          <Select2 :options="filterScrapingServiceName" v-model="query.scrapingServiceName"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>App Name</label>
          <Select2 :options="filterAppName" v-model="query.appName"/>
        </div>

        <div class="col-md-3">
          <label for="type-period">Period type</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="created_at">created_at</option>
            <option value="updated_at">updated_at</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="consult-day">Start date</label>
          <input v-model="query.startDate" type="date" id="consult-day" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">End date</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>

    <hr/>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          class="btn btn-primary mt-1 mr-1"
          @click="reprocess()"
          :disabled="disabledReprocess"
        >
          Reprocessar consultas
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="name">Nome</option>
          </select>
        </div>

        <button
          class="btn btn-outline ml-3 mb-1"
          v-if="orders.length > 0"
          @click="changeCheckAll"
          :class="{ 'btn-outline-active': checkAll}"
        >
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow"/>
              </th>
              <th>ID</th>
              <th></th>
              <th>Account</th>
              <th>App</th>
              <th>Status</th>
              <th>Stage</th>
              <th>Service</th>
              <th>Created at</th>
              <th>Updated at</th>
              <th>Created by</th>
              <th>Requested by</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>
                <BkpsCheckBox v-model="order.checked" @input="$emit('changeCheckRow', $event)" />
              </td>
              <td>
                {{ order.id }}
              </td>
              <td>
                <CopyIcon @click="clipboardUUID(order.uuid)" class="fd-icon ml-1" v-tooltip.right="'Copiar UUID'"/>
              </td>
              <td>{{ getAccountName(order) }}</td>
              <td>{{ order.appName }}</td>
              <td>{{ showStatus(order.status) }}</td>
              <td>{{ order.stageName }}</td>
              <td>{{ order.input.scrapingServiceName }}</td>
              <td>{{ order.createdAt | datetime }}</td>
              <td>{{ order.updatedAt | datetime }}</td>
              <td>{{ order.createdBy }}</td>
              <td>{{ order.requestedBy }}</td>
              <td>
                <Dropdown title-dropdown="Opções" class="col-md ml-2 btn-sm btn-primary" position="right"> 
                  <ul class="mb-1 mt-1">
                    <li class="dropdown-item">
                      <div @click="show(order)">
                        Ver
                      </div>
                    </li>
                    <li class="dropdown-item">
                      <router-link :to="buildLink(order.id)">
                        Detalhes
                      </router-link>
                    </li>
                  </ul>
                </Dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ModalDetail v-model="showModal" :order="currentOrder"/>
    <ShowDataModal v-if="false" v-model="showModal" header="Order" :order="currentOrder"/>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import CheckedModels from '@/mixins/CheckedModels'

import Dropdown from '@/components/shares/specialTag/Dropdown.vue'
import ModelMapper from '@/mixins/ModelMapper'
import handleSearchable from '@/models/handleSearchable'
import GetUser from '@/mixins/GetUser'

import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ShowDataModal from '@/components/admin/ShowDataModal'

import ModalDetail from './ModalDetail'

import {Filter} from '@/models/filter'
import {ChevronDownIcon, CopyIcon, SearchIcon} from 'vue-feather-icons'

const ORDER_KIND = 'consult'
let mapStatus = null

const reprocessConsults = (consults, instance) => {
  let delay = 0
  instance.openLoad()
  consults.forEach(consult => {
    setTimeout(() => reprocessConsult(consult, instance), delay)
    delay += 500
  })

  setTimeout(() => {
    instance.closeLoad()
    instance.asyncTemplateSelect({
      pagination: true
    })
  }, delay)
}

const reprocessConsult = (consult, instance) => {
  instance.axios.post(`admin/maestro/orders/${consult.id}/reprocess_consult?next_target=send_to_scraper`)
    .then(() => instance.$notify.add('Consulta reprocessada'))
    .catch(e => instance.$notify.addError(e))
}

const scheduleReprocessConsult = (query, instance) => {
  const params = {...query, next_target: 'send_to_scraper'}
  instance.openLoad()
  instance.axios.post('admin/maestro/orders/reprocess_consults', params)
    .then(() => instance.$notify.add('Consultas agendadas'))
    .catch(e => instance.$notify.addError(e))
    .finally(() => {
      instance.checkAll = false
      instance.checkAllRow = false
      instance.orders.forEach(c => c.checked = false)
      instance.closeLoad()
    })
}

export default {
  components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, Dropdown, CopyIcon, Pagination, SearchIcon, ShowDataModal,
    ModalDetail,
    Select2 },
  computed: {
    orders() {
      return this.getModels || []
    },
    badgeFilters() {
      return [
        this.filterStatus,
        this.filterAppName,
        this.filterStageName,
        this.filterAccount,
        this.filterEndDate,
        this.filterStartDate,
        this.filterScrapingServiceName
      ]
    },
    disabledReprocess() {
      return !this.orders.some(c => c.checked)
    }
  },
  created() {
    if (this.$utils.isEmpty(this.query.startDate)) {
      const str = this.$utils.toDateInput()
      this.$set(this.query, 'startDate', str)
    }

    mapStatus = {}
    this.$set(this.query, 'periodType', 'created_at')
    this.defaultModelSetting.updateQueryURL = true
    this.query.kind = ORDER_KIND

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true,
      after: () => this.mountFilters()
    })
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    this.buildFilterServiceNames()
  },
  data: () => ({
    currentOrder: {},
    currentPath: 'admin/maestro/orders',
    filterStatus: null,
    filterAppName: null,
    filterStageName: null,
    filterAccount: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterScrapingServiceName: null,
    showModal: false,
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Order',
    orderBy: 'created_at',
  }),
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    buildParams(pagination) {
      if (this.query.generic)
        this.query.generic = handleSearchable(this.query.generic)

      return ModelMapper.methods.buildParams.call(this, pagination)
    },
    buildLink(orderId) {
      return `/admin/maestro/manager-consults/${orderId}`
    },
    find() {
      this.query.kind = ORDER_KIND
      this.asyncTemplateSelect()
    },
    showStatus(status) {
      if (Object.keys(mapStatus).length > 0)
        return mapStatus[status]

      if (!this.filterStatus)
        return status

      this.filterStatus.forEach(obj => mapStatus[obj.value] = obj.label)
      return mapStatus[status]
    },
    mountFilters() {
      const key = `${this.currentPath}/fetch_columns`
      const mount = (data) => {
        this.filterStatus = new Filter({key: 'status', label: 'Status', table: data['status']})
        this.filterAppName = new Filter({key: 'appName', label: 'AppName', table: data['app_name']})
        this.filterStageName = new Filter({key: 'stageName', label: 'StageName', table: data['stage_name']})
      }

      const data = this.$ls.get(key)
      if (data)
        return mount(data)

      this.axios.get(key)
        .then(response => {
          mount(response.data)
          this.$ls.set(key, data, {minutes: 5})
        })
    },
    buildFilterServiceNames() {
      this.filterScrapingServiceName = new Filter({
        key: 'scrapingServiceName',
        label: 'Service',
        table: [
          ['ANTT', 'autos_antt'],
          ['ANTT PROCESSOS', 'autos_antt_processos'],
          ['DNIT', 'autos_dnit'],
          ['DER SP', 'autos_embarcador_der_sp'],
          ['DER PR', 'autos_der_cnd_pr'],
        ]
      })
    },
    clipboardUUID(uuid) {
      const input = document.createElement('input');
      input.value = uuid
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    },
    reprocess() {
      let amount
      let target
      let method

      if (this.checkAll) {
        amount = this.meta.totalCount
        target = this.buildParams()
        method = scheduleReprocessConsult
      } else {
        target = this.orders.filter(c => c.checked)
        amount = target.length
        method = reprocessConsults
      }

      if (!confirm(`Reprocessar ${amount} Consulta(s).\nTem certeza?`))
        return

      method(target, this)
    },
    show(item) {
      this.showModal = true
      this.currentOrder = item
    },
    changeCheckAll() {
      this.changeCheck({ checkAll: !this.checkAll, sources: this.orders })
    },
    changeCheckAllRow(value) {
      this.changeCheck({ checkAllRow: value, sources: this.orders })
    },
    changeCheckRow(){
      this.changeCheck({ sources: this.orders })
    },
  },
  mixins: [CheckedModels, ModelMapper, GetUser],
  name: 'AdminManagerConsultsIndex',
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  },
}
</script>
<style scoped>
</style>
